import React from 'react';
import './label.scss';


export default props => {

  let { label, type, value, col, link, url } = props;
  let colP = "";

  if (col === "50") {
    col = "col-50"
    colP = "col-50"
  } else if (col === "75") {
    col = "col-75"
    colP = "col-25"
  } else if (col === "100") {
    col = "col"
  } else {
    col = "col-25"
    colP = "col-75"
  }

  if (type === "title") {
    return (
      <div className="componente-title">
        <p className="label">{label}</p>
      </div>
    );
  } else {
    return (
      <div className="component-p">
        {label && <div className={col}><p className="label">{label}</p></div>}
        {link && <div className={col}><p onClick={() => { props.history.push(url) }} className="link">{link}</p></div>}
        <div className={colP}><p className="labelValue">{value}</p></div>
      </div>
    );
  }
}

